import { MutationTree } from "vuex";
import { CalendarState, Calendar } from "./model";

const mutations: MutationTree<CalendarState> = {
  setCalendars(state, calendars: Calendar[]) {
    state.calendars = calendars
  },
  addCalendar(state, calendar: Calendar) {
    state.calendars.push(calendar)
  },
  updateCalendar(state, calendar: Calendar) {
    const pos = state.calendars.findIndex(c => c.id === calendar.id);
    if(pos !== -1) {
      state.calendars.splice(pos, 1, calendar);
    }
  },
  deleteCalendar(state, id: string) {
    state.calendars = state.calendars.filter(calendar => calendar.id !== id)
  }
}

export default mutations;
